export const commonFrameRate = 24

export const trackKinds = {
    audio: 'audio',
    video: 'video',
    data: 'data',
}

export const mediaSources = {
    audio: 'audio',
    camera: 'camera',
    screen: 'screen',
}

export const trackPriorities = {
    HIGH: 'high',
    STANDARD: 'standard',
    LOW: 'low',
}

export const mediaStates = {
    OFF: 'off',
    ON: 'on',
}

export const videoDimensions = {
    qcif: {
        width: 176,
        height: 144,
        frameRate: commonFrameRate,
    },
    cif: {
        width: 352,
        height: 288,
        frameRate: commonFrameRate,
    },
    vga: {
        width: 640,
        height: 480,
        frameRate: commonFrameRate,
    },
    wvga: {
        width: 720,
        height: 480,
        frameRate: commonFrameRate,
    },
    v540p: {
        width: 960,
        height: 540,
        frameRate: commonFrameRate,
    },
    HD: {
        width: 1280,
        height: 720,
        frameRate: commonFrameRate,
    },
    v960p: {
        width: 1280,
        height: 960,
        frameRate: commonFrameRate,
    },
    standard1080p: {
        width: 1440,
        height: 1080,
        frameRate: commonFrameRate,
    },
    FHD: {
        width: 1920,
        height: 1080,
        frameRate: commonFrameRate,
    },
}
